<template>
  <div>
    <div class="to_downloadAn" v-if="!iosShow">
      <!-- <image src="../../static/images/bg-img/downloadAn.png" mode=""></image> -->
      <img src="../../assets/images/downloadAn.png" alt="" />
      <p>
        在浏览器打开，<br />
        下载长尾巴月读社
      </p>
    </div>
    <div class="icon_box">
      <image src="../../unpackage/res/icons/167x167.png" mode=""></image>
      <p>长尾巴月读社</p>
    </div>
    <button v-if="iosShow" class="download_btn" @click="download('ios')">
      通过App Store下载
    </button>
    <button v-else class="download_btn" @click="download('android')">
      Android下载
    </button>
    <!-- <a href="http://yy.duzhexinyuwen.com:8001/Upload/cwb.apk">Android</a> -->
    <div class="copyright_box">
      <p class="copyright">读者出版传媒股份有限公司 版权所有</p>
    </div>
  </div>
</template>

<script>
// import { GetAppDownloadLink } from "@/api/user.js";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      iosShow: false,
      wx: false,
      type: "",
    };
  },
  mounted() {
    // if (uni.getSystemInfoSync().platform == 'ios') {
    // 	this.iosShow = true
    // 	this.type='ios'
    // } else {
    // 	this.iosShow = false
    // 	this.type='android'
    // }
    // var ua = navigator.userAgent.toLowerCase()
    // var isWeixin = ua.indexOf('micromessenger') != -1
    // if (isWeixin) {
    // 	this.wx=true
    // }
  },
  onLoad() {
    // setTimeout(() => {
    //   this.download("ios");
    // }, 500);
  },
  methods: {
    download(e) {
      let loadingInstance = Loading.service({ fullscreen: true });
      setTimeout(() => {
        loadingInstance.close();
      }, 5000);
      //   if (e == "ios") {
      //     window.location.href = "itms-apps://itunes.apple.com/app/id979093695";
      //   } else if (e == "android") {
      //     GetAppDownloadLink().then((res) => {
      //       if (res.tag == 1) {
      //         window.location.href = res.message;
      //       } else {
      //         uni.showToast({
      //           title: "出现错误",
      //           icon: "none",
      //         });
      //       }
      //     });
      //   }
    },
  },
};
</script>

<style>
.icon_box {
  height: 47vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 13vh;
  box-sizing: border-box;
}

.icon_box img {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
}

.icon_box p {
  font-family: PingFangSC;
  font-size: 36rpx;
  color: #000000;
}

.download_btn {
  width: 260px;
  height: 40px;
  background-color: #1e82fe;
  border-radius: 4px;
  font-family: PingFangSC;
  color: #ffffff;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.copyright_box {
  height: calc(40vh - 40px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.copyright {
  font-family: PingFangSC-Bold;
  font-size: 26rpx;
  font-weight: normal;
  font-stretch: normal;
  line-height: 72rpx;
  letter-spacing: 0px;
  color: #999999;
}

.to_downloadAn {
  position: fixed;
  right: 20px;
  width: 200px;
  height: 120px;
}

.to_downloadAn image {
  width: 100%;
  height: 100%;
  position: absolute;
}

.to_downloadAn p {
  color: #333333;
  font-family: PingFangSC;
  font-size: 15px;
  position: absolute;
  top: 30px;
  left: 34px;
}
</style>
